









import { Component, Vue } from 'vue-property-decorator';
import VxBreadcrumb from '@/layouts/components/VxBreadcrumb.vue';
import BookingComponent from '@/components/common/BookingComponent.vue';
import { getBookingPrescriber } from '@/api/api';
import router from '@/router';

@Component({
    beforeRouteEnter: async (to, from, next) => {
        // url de réservations
        const { route } = router.resolve({
            name: 'bookingsPrescriber',
        });
        to.meta.breadcrumb[1].url = route.fullPath;

        // Nom du lot de la réservation
        try {
            const { data } = await getBookingPrescriber(+to.params.bookingID);
            const booking = data;

            if (booking.lot) {
                to.meta.breadcrumb[2].title = booking.code;
            }
        } catch (error) {
            if (error.response.status == 404) {
                Vue.prototype.$vs.notify({
                    color: 'danger',
                    position: 'top-right',
                    title: 'Erreur',
                    text: `Réservation introuvable.`,
                });

                next({
                    name: 'bookingsPrescriber',
                });
                return;
            }
        }
        next();
    },
    components: {
        VxBreadcrumb,
        BookingComponent,
    },
})
export default class BookingPrescriber extends Vue {}
